import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "s-modal__header-title" }
const _hoisted_2 = { class: "s-modal__body" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "s-modal__footer full-width row justify-end q-mt-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    persistent: _ctx.persistent,
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: _normalizeClass(["s-modal q-dialog-plugin", _ctx.classes])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, { class: "s-modal__header-wrapper" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar_title, { class: "" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", { innerHTML: _ctx.message }, null, 8, _hoisted_3),
            _renderSlot(_ctx.$slots, "body")
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.cancel)
              ? (_openBlock(), _createBlock(_component_s_btn, {
                  key: 0,
                  "no-caps": "",
                  class: "s-mr-md",
                  type: _ctx.reverseBtn ? 'light' : 'brand',
                  label: _ctx.cancelLabel,
                  onClick: _ctx.onCancelClick
                }, null, 8, ["type", "label", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_s_btn, {
              "no-caps": "",
              type: _ctx.reverseBtn ? 'brand' : 'light',
              label: _ctx.confirmLabel,
              onClick: _ctx.onOKClick
            }, null, 8, ["type", "label", "onClick"])
          ])
        ]),
        _: 3
      }, 8, ["class"])
    ]),
    _: 3
  }, 8, ["persistent", "onHide"]))
}